// extracted by mini-css-extract-plugin
export default {"tasks":"SN-z","task":"TN-z","svg":"UN-z","text":"VN-z"};